import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ClientColorPicker } from '../components/ClientColorPicker';
import { ClientContext } from '../../ClientContext';
import { ClientErrorContext } from '../../ClientErrorContext';

export function ClientColor() {
    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);

    return (
        <Grid container direction="column" spacing={3}>
            <Grid item xs={12}>
                <Typography variant="subtitle1">
                Cores do Dashboard
                </Typography>
            </Grid>
            <Grid item>
                <ClientColorPicker 
                    name={'Cor primária'}
                    color={clientContext.primaryColor}
                    setColor={clientContext.setPrimaryColor}
                    colorError={clientErrorContext.primaryColorError} 
                    setColorError={clientErrorContext.setPrimaryColorError}
                    colorNotDefinedError={clientErrorContext.primaryColorNotDefinedError} />
            </Grid>
            <Grid item>
                <ClientColorPicker 
                    name={'Cor secundária'}
                    color={clientContext.secondaryColor}
                    setColor={clientContext.setSecondaryColor}
                    colorError={clientErrorContext.secondaryColorError} 
                    setColorError={clientErrorContext.setSecondaryColorError}
                    colorNotDefinedError={clientErrorContext.secondaryColorNotDefinedError} />
            </Grid>
        </Grid>
    );
}